import Container from 'common/components/container.component';
import { PaymentStatus } from 'config/constants/order.constants';
import { RouteName } from 'config/constants/route.constants';
import { OrderTranscription } from 'config/constants/transcription.constant';
import { ConfirmPurchaseResponse } from 'config/types/order.type';
import FailedPayment from 'order/components/failed-payment.component';
import SuccessPayment from 'order/components/success-payment.component';
import React from 'react';
import { Link } from 'react-router-dom';
import { Purchase } from 'store/models/order.model';
import { User } from 'store/models/user.model';

type PurchaseResultContainerProps = {
  user: User;
  entryCode: string | null;
  confirmedPurchaseResponse?: ConfirmPurchaseResponse;
  purchase?: Purchase;
  pollState?: 'checking' | 'paid' | 'failed' | 'unresolved';
};

const PurchaseResultContainer: React.FC<PurchaseResultContainerProps> = ({
  user,
  entryCode,
  confirmedPurchaseResponse,
  purchase,
  pollState = 'checking',
}) => {
  const { paymentStatus } = confirmedPurchaseResponse ?? {};

  return (
    <Container>
      {pollState === 'unresolved' && (
        <div>
          <p>{OrderTranscription.PAYMENT_CONFIRMING}</p>
          <Link to={RouteName.MY_PURCHASES}>{OrderTranscription.GO_TO_MY_PURCHASES}</Link>
        </div>
      )}
      {(paymentStatus === PaymentStatus.FAILED || pollState === 'failed') && (
        <FailedPayment user={user} confirmedPurchaseResponse={confirmedPurchaseResponse} />
      )}
      {(paymentStatus === PaymentStatus.SUCCESS || pollState === 'paid') && purchase && (
        <SuccessPayment user={user} entryCode={entryCode} purchase={purchase} />
      )}
    </Container>
  );
};

export default PurchaseResultContainer;
